"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when clock skew cannot be fixed, resulting in server blocking requests
 * @param {string} reason
 */
class UnrectifiableClockSkewError extends ExtendableError_1.default {
    constructor(reason) {
        super(reason);
    }
}
exports.default = UnrectifiableClockSkewError;
